import {
  Button,
  Card,
  Col,
  Empty,
  Flex,
  Pagination,
  Row,
  Space,
  Typography
} from 'antd';
import { CloseThreadModal } from 'components/modal/faq-coordenator/CloseThreadModal';
import { CommentOutlined } from '@ant-design/icons';
import { CreatePostModal } from 'components/modal/faq-coordenator/CreatePostModal';
import {
  IFAQCoordinator,
  IFAQCoordinatorPost
} from 'interfaces/faq_coordinators';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { Post } from './components/Posts';
import { ShowFieldData } from 'components/ShowFieldData';
import { ShowLayout } from '../../../components/layout/layout/ShowLayout';
import { TagField, useModal } from '@refinedev/antd';
import { statusMap } from 'services/faq-coordinator';
import { useList, useShow } from '@refinedev/core';
import { useParams } from 'react-router-dom';
import { useState } from 'react';

export const FaqCoordinatorsShow = () => {
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const { queryResult } = useShow<IFAQCoordinator>();
  const { data, isLoading, refetch } = queryResult;
  const { data: postData } = useList<IFAQCoordinatorPost>({
    resource: `faq_coordinators/${id}/posts`,
    pagination: {
      current: currentPage,
      pageSize: 10,
      mode: 'server'
    }
  });

  const { data: firstPostData } = useList<IFAQCoordinatorPost>({
    resource: `faq_coordinators/${id}/posts`,
    pagination: {
      current: currentPage,
      pageSize: 1,
      mode: 'server'
    }
  });

  const record = data?.data;

  const postRecords =
    currentPage === 1 ? postData?.data?.slice(1) : postData?.data;

  const {
    show: postCreateModalShow,
    close: postCreateModalClose,
    modalProps: postCreateModalProps
  } = useModal();

  const {
    show: closeTopicModalShow,
    close: closeTopicModalClose,
    modalProps: closeTopicModalProps
  } = useModal();

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <ShowLayout isLoading={isLoading}>
      <PageHeader
        title={record?.title || 'Visualizar tópico'}
        icon={CommentOutlined}
        meta={
          <Flex>
            <TagField
              value={statusMap[record?.status as keyof typeof statusMap]?.label}
              color={statusMap[record?.status as keyof typeof statusMap]?.color}
            />
          </Flex>
        }
        actions={
          <>
            {record?.status !== 'closed' && (
              <Space>
                <Button type="default" onClick={closeTopicModalShow}>
                  Marcar como concluído
                </Button>

                <Button
                  type="primary"
                  className="!shadow-none"
                  onClick={postCreateModalShow}
                >
                  Responder
                </Button>
              </Space>
            )}
          </>
        }
      />
      <Card>
        <Row gutter={[16, 16]} className="w-full mb-2">
          <Col span={12}>
            <ShowFieldData
              label="Nome"
              value={
                record?.author.full_name_or_name ?? record?.author.name ?? '--'
              }
            />
          </Col>
          <Col span={12}>
            <ShowFieldData
              label="E-mail"
              value={record?.author.email ?? '--'}
            />
          </Col>
        </Row>

        <Row gutter={[16, 16]} className="w-full mb-2">
          <Col span={12}>
            <ShowFieldData label="Curso" value={record?.grandparent?.name} />
          </Col>
          <Col span={12}>
            <ShowFieldData label="Categoria" value={record?.category?.name} />
          </Col>
        </Row>

        <Row className="w-full">
          <Col span={24}>
            <ShowFieldData
              label="Texto"
              value={firstPostData?.data?.[0]?.text}
            />
          </Col>
        </Row>

        <Card className="mt-8">
          <Typography.Title level={5}>Respostas</Typography.Title>

          <div className="w-full mt-5 divide-y divide-slate-200">
            {postRecords && postRecords?.length < 1 && (
              <div className="w-full flex justify-center py-6">
                <Empty description="Este forum ainda não possui respostas." />
              </div>
            )}
            {postRecords?.map(post => (
              <Post key={post.id} post={post} />
            ))}
          </div>

          <Row className="w-full flex justify-start">
            <Pagination
              total={postData?.total}
              hideOnSinglePage
              onChange={handlePageChange}
              className="mt-4"
            />
          </Row>
        </Card>

        <CreatePostModal
          forumId={id}
          modalProps={postCreateModalProps}
          modalClose={postCreateModalClose}
          refetch={refetch}
        />

        <CloseThreadModal
          forumId={id}
          modalProps={closeTopicModalProps}
          modalClose={closeTopicModalClose}
          refetch={refetch}
        />
      </Card>
    </ShowLayout>
  );
};
